import { render } from "./ParcelNumbersControl.vue?vue&type=template&id=27ec3bcd&ts=true"
import script from "./ParcelNumbersControl.vue?vue&type=script&lang=ts"
export * from "./ParcelNumbersControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__